"use client";

import { getUsersName } from "@/api/users/helpers";
import ArtistTipModal from "../ArtistTipModal/ArtistTipModal";
import TipIcon from "@/assets/icons/tip.svg";
import { Button } from "@/app/(components)/Basic/Button";
import { User } from "@/api/users/types";
import useModalToggle from "@/shared/hooks/useToggleModal";
import useWithCorrectNetwork from "@/shared/hooks/useWithCorrectNetwork";

export interface Props {
  user: User;
}

const ArtistTipModalButton = ({ user }: Props) => {
  const [isTipModalOpen, toggleTipModal] = useModalToggle();

  const checkedToggle = useWithCorrectNetwork(toggleTipModal);

  return (
    <>
      <ArtistTipModal
        isOpen={isTipModalOpen}
        onClose={toggleTipModal}
        imageUrl={user.imageUrl!}
        imagePlaceholder={user.imagePlaceholder}
        fullName={getUsersName(user, true)}
        recipient={user}
      />
      <Button startIcon={<TipIcon className="w-5" />} onClick={checkedToggle}>
        Tip
      </Button>
    </>
  );
};

export default ArtistTipModalButton;
